import { LitElement, html, nothing } from 'lit';
import fsTypoStyles from '@cof/fs-typography-core/lib/typography.lit';
import fsButton from '@cof/fs-button-core/lib/button.lit.min.js';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { style } from './step-iconic-income-v2.style.js';
import { globalStyle } from '../../../../global-styles.style.js';
import { ApplicationService } from '../../../../services/application.service.js';
import '../../step-income/job/job.component.js';
import '../../step-income/income/income.component.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiStepIconicIncomeComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepIconicIncome');
    this.application = {};
    this.validity = {};
    this.showAdditionalIncome = false;
    this.PQV2 = false;
    this.isPrefill = false;
    this.childIds = {};
  }

  static properties = {
    application: { type: Object, reflect: true },
    applicant: { type: Object, reflect: true },
    isPrefill: { type: Boolean, attribute: 'is-prefill' },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
    showAdditionalIncome: { type: Boolean, reflect: true },
  };

  static styles = [style, globalStyle, fsTypoStyles, fsButton];

  connectedCallback() {
    super.connectedCallback();
    this.initializeProperties();
  }

  initializeProperties() {
    this.PQV2 = ApplicationService.isIconicV2;

    this.application = ApplicationService.Application;
    this.applicant = this.isPrimary
      ? this.application.primaryApplicant
      : this.application.coApplicant;
    this.coAppPrefix = this.isPrimary ? '' : 'co-';

    this.childIds = {
      income: `${this.coAppPrefix}income-input`,
      additionalIncome: `${this.coAppPrefix}additional-income-input`,
    };

    this.resetValues();
  }

  resetValues() {
    this.application = ApplicationService.Application;
    this.applicant = this.isPrimary
      ? this.application.primaryApplicant
      : this.application.coApplicant;

    this.showAdditionalIncome = !!this.applicant.otherIncome ?? false;

    const incomeField = this.shadowRoot.getElementById(this.childIds.income);
    const additionalIncomeField = this.shadowRoot.getElementById(
      this.childIds.additionalIncome
    );

    incomeField?.resetValues();
    additionalIncomeField?.resetValues();
  }

  render() {
    return html`
      <form
        id="step-iconic-income-form"
        class="step-iconic-income-form"
        novalidate
      >
        <refi-personal-income
          id="${this.childIds.income}"
          @validity="${this.updateValidity}"
          ?is-primary="${this.isPrimary}"
          ?iconic-v2=${true}
        ></refi-personal-income>

        <div class="button-container-iconic">
          <button
            class="step-income__add-additional-source fs-button fs-button--primary fs-button--compact fs-button--ghost"
            aria-expanded="${this.showAdditionalIncome}"
            @click="${this.toggleAdditionalIncome}"
            @keydown="${this.handleKeyDown}"
          >
            ${this.showAdditionalIncome
              ? html`- Remove another source of income`
              : html`+ Add another source of income`}
          </button>
        </div>
        ${this.showAdditionalIncome
          ? html`
              <refi-personal-income
                id="${this.childIds.additionalIncome}"
                additional-amount
                @validity="${this.updateValidity}"
                ?is-primary="${this.isPrimary}"
                ?iconic-v2=${true}
              ></refi-personal-income>
            `
          : nothing}
      </form>
    `;
  }

  toggleAdditionalIncome(ev) {
    ev.preventDefault();
    stratum.publishTag(TagKey.PERSONAL_INCOME_ADD_ADDITIONAL_INCOME, {
      replacements: { value: `${this.isPrimary ? 'primary' : 'coBorrower'}` },
    });
    this.showAdditionalIncome = !this.showAdditionalIncome;
    delete this.validity.incomeAmountOther;
  }

  handleKeyDown(ev) {
    if (ev.key === 'Enter') {
      this.toggleAdditionalIncome(ev);
    }
  }

  updateValidity(ev) {
    this.validity[ev.detail.name] = ev.detail.isValid;

    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: 'income',
          isValid: ev.detail.isValid,
        },
      })
    );
  }

  saveToApplication() {
    const incomeElement = this.shadowRoot.getElementById(this.childIds.income);
    const additionalIncomeElement = this.shadowRoot.getElementById(
      this.childIds.additionalIncome
    );

    this.application[
      this.isPrimary ? 'primaryApplicant' : 'coApplicant'
    ].incomeAmount = Math.abs(incomeElement.values.incomeAmount);
    this.application[
      this.isPrimary ? 'primaryApplicant' : 'coApplicant'
    ].otherIncome = this.showAdditionalIncome
      ? Math.abs(additionalIncomeElement.values.otherIncome)
      : 0;
  }
}

customElements.define(
  'refi-step-iconic-income-v2',
  RefiStepIconicIncomeComponent
);
